/**
 * ColorSetting Style04 - Stitch v2：gold 主題、palette、spectrum 滑桿、5 色塊
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'
import './ColorSettingStyle04.css'

const PRESET_COLORS = [
  { hue: 0, bg: '#ef4444' },
  { hue: 220, bg: '#3b82f6' },
  { hue: 120, bg: '#22c55e' },
  { hue: 55, bg: '#eab308' },
  { hue: 270, bg: '#a855f7' },
]

export function ColorSettingStyle04({
  state,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const hueFromState = (state?.spectrumHSV as { hue?: number })?.hue ?? (state?.hue as number)
  const currentHue = typeof hueFromState === 'number' ? Math.max(0, Math.min(360, Math.round(hueFromState))) : 180
  const [hue, setHue] = useState(currentHue)

  useEffect(() => {
    const v = typeof hueFromState === 'number' ? Math.max(0, Math.min(360, Math.round(hueFromState))) : 180
    setHue(v)
  }, [hueFromState])

  const handleSliderChange = (value: number) => {
    const safe = Math.max(0, Math.min(360, Math.round(value)))
    setHue(safe)
    void onCommand('setColor', { color: { spectrumHSV: { hue: safe, saturation: 1, value: 1 } } })
  }

  const handleSwatchClick = (h: number) => {
    if (disabled) return
    setHue(h)
    void onCommand('setColor', { color: { spectrumHSV: { hue: h, saturation: 1, value: 1 } } })
  }

  return (
    <div className="trait-colorsetting-style04 trait-stitch-v2-glass">
      <div className="trait-colorsetting-style04__header">
        <span className="trait-colorsetting-style04__title">Color Setting</span>
        <span className="material-symbols-outlined trait-colorsetting-style04__icon">palette</span>
      </div>
      <div
        className="trait-colorsetting-style04__slider-wrap"
        style={{ '--thumb-hue': hue } as React.CSSProperties}
      >
        <input
          type="range"
          min={0}
          max={360}
          value={hue}
          onChange={(e) => setHue(Number(e.target.value))}
          onMouseUp={(e) => handleSliderChange(Number((e.target as HTMLInputElement).value))}
          onTouchEnd={(e) => handleSliderChange(Number((e.target as HTMLInputElement).value))}
          className="trait-colorsetting-style04__slider"
          disabled={disabled}
        />
      </div>
      <div className="trait-colorsetting-style04__swatches">
        {PRESET_COLORS.map(({ hue: h, bg }) => (
          <button
            key={h}
            type="button"
            className={`trait-colorsetting-style04__swatch ${Math.abs(hue - h) < 20 ? 'selected' : ''}`}
            style={{ backgroundColor: bg }}
            onClick={() => handleSwatchClick(h)}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  )
}
